export const HOST = [
    'https://ams-customer-us-test.tigerbrokers.net/support',
    'https://customer.tradeup.com/support',
    'https://ams-customer-us-test.tigerbrokers.net/support'
];
export const API = {
    getAgreementContentById: '/api/v1/agreements/:id',
    /**
     * https://apidocs.tigerfintech.com/repository/23/api/master/APP-Web.json#/operations/get--api-v1-{category}-agreements-supplement
     * RD renjianjun
     */
    getAgreements: '/api/v1/individual/agreements/supplement', // 升级协议
    // https://apidocs.tigerfintech.com/repository/23/api/master/APP-Web.json#/operations/get-api-v1-agreements @sunzhenzhao
    getAgreementsByLinkCodes: '/api/v1/agreements',
    // https://apidocs.tigerfintech.com/repository/23/api/master/APP-Web.json#/operations/get-api-v2-agreement-link_code
    getAgreementContentByLinkCode: '/api/v2/agreement/:link_code',
    /**
     * 协议相关 https://wiki.tigerbrokers.net/pages/viewpage.action?pageId=45843480 @郭江帅
     */
    openIndividualAgreements: '/api/v1/individual/agreements/open_account', // 获取个人开户协议列表
    openIRAAgreements: '/api/v1/ira/agreements/open_account', // 获取IRA协议列表
    getWebWidget: '/api/v1/chat/jwt' // 获取JWT_TOKEN_ENDPOINT
};

// 使用cg返回的数据，如果有牌照或者region等多种域名区分，需要在这里逐一展开
export function bindCG() {
    const cfg = CG_API.customerSupport?.COMMON;

    cfg && HOST.fill(cfg);
}
